import Vue from "vue";
import VueAnalytics from "vue-analytics";

import App from "@/views/App.vue";
import router from "@/router";

// Vuescroll
import vuescroll from "vuescroll/dist/vuescroll-slide";
import "vuescroll/dist/vuescroll.css";
import store from "@/store";
import langUtil, { StringKey } from "@/utils/lang.util";

// Lottie animations
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

import "./registerServiceWorker";

// Font awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas as any);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// Cookie consent
import "../node_modules/cookieconsent/build/cookieconsent.min.css";
import "../node_modules/cookieconsent/build/cookieconsent.min.js";

// Axios interseptor
import createAxiosInstance from '@/services/axiosInterseptors';
import locationService from "./services/location.service";
import userUtil from "./utils/user.util";

const axiosInstance = createAxiosInstance(store);

declare global {
  interface Window {
    cookieconsent: any;
  }
}

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: "UA-76346427-3",
  router,
  disabled:
    window.cookieconsent.utils.getCookie("cookieconsent_status") === "deny",
});

Vue.use(vuescroll);

Vue.use(LottieVuePlayer);

Vue.prototype.$http = axiosInstance;

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
});

(async () => {
  try {
    const countryCode = await locationService.getLocationCountryCode();
    userUtil.setCountryCode(countryCode);
    app.$mount('#app');
  } catch (error) {
    app.$mount('#app');
  }
})();

// Cookie consent
const lang = navigator.language ? navigator.language.split("-")[0] : null;
try {
  if (VK_0) {
    // Empty block to detect vewd TV
  }
} catch (error) {
  window.cookieconsent.initialise({
    palette: {
      popup: {
        background: "#4f4f4f",
        text: "#ffffff",
      },
      button: {
        background: "#4fc3f7",
        text: "#ffffff",
      },
    },
    type: "opt-out",
    theme: "edgeless",
    content: {
      message: langUtil.getLang().t(StringKey.CmpText),
      dismiss: "Ok!",
      allow: langUtil.getLang().t(StringKey.CmpAllow),
      deny: langUtil.getLang().t(StringKey.CmpDeny),
      link: langUtil.getLang().t(StringKey.CmpMore),
      href:
        lang && ["fr", "es", "nl", "de", "it", "ar"].indexOf(lang) >= 0
          ? `https://www.kidjo.tv/${lang}/privacy`
          : "https://www.kidjo.tv/privacy",
    },
    cookie: {
      name: "cookieconsent_status",
    },
    onStatusChange() {
      const type = this.options.type;
      const didConsent = this.hasConsented();
      if (type === "opt-out" && !didConsent) {
        // Disable Google analytics
        (Vue as any).$ga.disable();
        // Remove its related cookies
        window.cookieconsent.utils.setCookie("_ga", null, -1);
        window.cookieconsent.utils.setCookie("_gat", null, -1);
        window.cookieconsent.utils.setCookie("_gid", null, -1);
      }
    },
    law: {
      regionalLaw: false,
    }
  });
}
